"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderYAxisTick = exports.renderXAxisTick = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var renderXAxisTick = function (_a) {
    var y = _a.y, payload = _a.payload;
    return ((0, jsx_runtime_1.jsx)("text", __assign({ textAnchor: "middle", className: "base", height: "260", stroke: "none", width: "60", x: payload.coordinate, y: y, fill: "#bdbdbd" }, { children: (0, jsx_runtime_1.jsx)("tspan", __assign({ x: payload.coordinate, dy: "0.9em" }, { children: payload.value })) })));
};
exports.renderXAxisTick = renderXAxisTick;
var renderYAxisTick = function (_a) {
    var x = _a.x, payload = _a.payload;
    return ((0, jsx_runtime_1.jsx)("text", __assign({ textAnchor: "end", stroke: "none", width: "50", height: "260", y: payload.coordinate, x: x, fill: "#bdbdbd", className: "base" }, { children: (0, jsx_runtime_1.jsx)("tspan", __assign({ y: payload.coordinate, dx: "-0.5em" }, { children: payload.value })) })));
};
exports.renderYAxisTick = renderYAxisTick;
//# sourceMappingURL=axisTickBuilder.js.map